import { Component, OnInit } from '@angular/core';
import { AccountGroupService, CreatedDateFilter, LookupFilter } from '@galaxy/account-group';
import { Observable } from 'rxjs';
import { CourseParams } from '../home-page-cards/home-page-card-footer/home-page-card-footer.component';

@Component({
  selector: 'app-business-account',
  templateUrl: './business-accounts.component.html',
  styleUrls: ['./business-accounts.component.scss'],
  providers: [AccountGroupService],
})
export class BusinessAccountsComponent implements OnInit {
  accountGroups$: Observable<any>;
  totalResults$: Observable<number>;
  manageAccountsPage = '/manage-accounts';
  businessSearchPage = '/business/search';
  courseParams: CourseParams = {
    text: 'HOME_PAGE.BUSINESS_ACCOUNTS.ACADEMY_LINK_TITLE',
    url: 'https://academy.conquerlocal.com/course/getting-started-with-the-vendasta-platform/?utm_source=pc-home-page',
    logo: '/images/icons/conquer-local.png',
  };

  constructor(private accountGroupService: AccountGroupService) {}

  ngOnInit(): void {
    this.totalResults$ = this.accountGroupService.totalResults;
    const lookupFilter = new LookupFilter();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    lookupFilter.createdDateFilter = new CreatedDateFilter(thirtyDaysAgo, new Date());
    this.accountGroups$ = this.accountGroupService.lookup(null, undefined, '', lookupFilter, 1);
  }
}
